export default __webpack_public_path__ + "static/media/meme.3bc58091.jpg";